import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'

Vue.use(MLInstaller)

export default new MLCreate({
  initial: 'English',
  save: process.env.NODE_ENV === 'development' | process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('English').create({
      english: 'English',
      german: 'German',
      serbian: 'Serbian',
      copyright: 'Copyright',
      log_out: 'Logout',
      language: 'Language',
      account: 'Account',
      register: 'Register',
      login: 'Login',
      forgot_password: 'Forgot password',
      reset_password: 'Reset password',
      new_password: 'New password',
      repeat_password: 'Repeat password',
      change_password: 'Change password',
      verify_account: 'Verify account',
      enter_email: 'Enter email',
      already_have_account: 'Already have an account?',
      boost_title: 'Your advertisement for boost',
      monthly_campaign: 'Monthy Campaign',
      one_time_campaign: 'One-time Campaign',
      monthly_campaign_settings: 'Monthly campaign Settings ',
      one_time_campaign_settings: 'One-time campaign Settings',
      campaign_investments: 'Campaign Investments:',
      sorry_more_credits: 'Sorry you need to buy more credit for this campaign. Your current balance: {credit}€',
      buy_more_credits: 'Buy more credit',
      per_view_price: 'Per View: 0.03€',
      per_click_price: 'Per Click: 0.05€',
      per_like_price: 'Per Like: 0.07€',
      prices: 'Preise',
      campaign_type: 'Campaign type',
      register_title1: 'Automate Marketing',
      register_desc1: 'Let your Wi-Fi do marketing for you.',
      register_title2: 'Collect Customer Data',
      register_desc2: 'Collect and analyze detailed guest data.',
      register_title3: 'Direct Marketing',
      register_desc3: 'Stay in touch with your guests via our Newsletter.',
      locations: 'Locations: ',
      wifi_posts: 'WiFi Posts',
      wifi_statistics: 'WiFi-Statistics',
      statistics: 'Statistics',
      clients: 'Clients',
      devices: 'Devices',
      aps: 'Access Points',
      urls: 'Url Shortening',
      accounts: 'Accounts',
      guests: 'Guests',
      message_service: 'Message Service',
      billboard_posts: 'Billboard Posts',
      indoor_billboards: 'Indoor Billboards',
      invoices: 'Invoices',

      invoice: 'Invoice',
      payment_method: 'Payment method',
      product: 'Product',
      net: 'Net',
      vat: 'VAT',

      refresh_hotspot: 'Refresh Hotspot',
      configuration: 'Configuration',
      package: 'Package',
      contact: 'Contact',
      help: 'Help',
      enter: 'Enter',
      create_new_ad: 'Create new post',
      enter_description: 'Enter Description',
      enter_title: 'Enter Title',
      enter_tags_text: 'Enter Tags - Max 5 - Choose existing one for more views, or create new one',
      enter_tag: 'Add Tag',
      selectMedias: 'Select Medias',
      online: 'Online devices',
      client: 'Client',
      client_statistics: 'Client Statistics',
      incl_investigation: 'Inclusive investigations',
      total_connections: 'Total Connections',
      average_daily_connections: 'Average daily connections',
      total_money_earned: 'Total money earned',
      money_earned_this_month: 'Money earned this month',
      monthly_connections: 'Monthly Connections',
      today: 'Today',
      reset_form: 'Reset form',
      advanced_settings: 'Advanced Settings',
      or: 'Or',
      no: 'No',
      coming_soon: 'Coming soon',
      connections: 'Connections',
      last_30_days: 'Frequency of connections during the last 30 days',
      last_24_hours: 'Showing connection in the last 24 hours',
      during_the_day_connections: 'Frequency of connections grouped hourly',
      weekly_connections: 'Weekly connections',
      connections_in_one_week: 'Showing weekly connection',
      during_the_week: 'Frequency of connections daily grouped',
      cancel: 'Cancel',
      gallery: 'Gallery',
      duration_in_sec: 'Duration in seconds',
      enter_duration_in_sec: 'Enter duration in seconds',
      select_file: 'Select file',
      upload_via_external_link: 'Upload from external link',
      upload: 'Upload',
      no_file: 'No file',
      drop_files: 'Drag & Drop files',
      upload_new: 'Upload new media',
      upload_media_type: 'Choose media type before upload',
      cancel_editing_promotion: 'Cancel',
      error: 'Error',
      created: 'Created',
      deleted: 'Deleted',
      data_not_valid: 'Data not valid',
      success: 'Success',
      active: 'Active',
      crop: 'Crop',
      and: 'And',
      credits_success_1: 'Your balance is updated',
      credits_success_2: 'Thank you for your trust!',
      credits_error_1: 'Sorry, your payment failed.',
      credits_error_2: 'No charges were made.',
      payment_type: 'Payment type',
      click_checkout: 'Click finish to pay',
      summary: 'Summary',
      credit: 'Credit',
      price: 'Price',
      amount: 'Amount',
      balance_after_deposit: 'Balance after deposit',
      buy_again: 'Buy again',
      buy_credits_title: 'Buy credit',
      choose_amount: 'Choose Amount',
      choose_type: 'Choose Typ',
      payment_option: 'Payment option',
      choose: 'Choose',
      birthday: 'Birthday',
      media: 'Media',
      photo: 'Photo',
      title: 'Title',
      description: 'Description',
      from: 'From',
      to: 'To',
      actions: 'Actions',
      showing: 'Showing {from} to {to} of {total} entries',
      next: 'Next',
      finish: 'Finish',
      user_filter: 'User Filter',
      recipients: 'Recipients',
      campaign_investment: 'Campaign investment - ',
      authorization_time: 'Guest WiFi Internet connection time | Value in minutes',
      company_filter: 'Company Filter',
      age: 'Age',
      gender: 'Gender',
      both: 'Both',
      male: 'Male',
      female: 'Female',
      message: 'Message',
      type_sms_150_long: 'Please type your {0} characters long SMS',
      make_email: 'Make your awesome email. ',
      total_receiving_message: 'Total receivers',
      total_costs_message: 'Total costs for this message',
      deposit: 'Deposit',
      total_costs: 'Total costs',
      total_guests: 'Total guests',
      current_balance: 'Current balance',
      remaining_credits: 'Remaining credit',
      email_html: 'Email',
      type_email_title: 'Type your email title',
      type_email_text: 'Type your email text',
      campaign: 'Campaign',
      success_campaign_message_1: 'Successfully created campaign.',
      success_campaign_message_2: 'Our team will review your campaign and start it as fast as possible. If there are some issues, we will contact you. Thanks for using our campaign service. :)',
      promoPage: 'Promotional Page after connection via hotspot',
      on: 'On',
      off: 'Off',
      login_priority: 'Guest WiFi login option priority | Email or SMS',
      login_on_visit: 'Login on Visit',
      explanation_configuration: 'Only own advertisements - If enabled, you can not earn credit by allowing others to use your advertising space',
      date_picker_texts : {
        night: 'Day',
        nights: 'Days',
        'day-names': ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],
        'check-in': 'Start date',
        'check-out': 'End date',
        'month-names': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      },
      print: 'Print',
      send_on_email: 'Send on email',
      boost: 'Boost',
      delete: 'Delete',
      type: 'Type',
      payment: 'Payment',
      date: 'Date',
      total: 'Total',
      status: 'Status',
      discount: 'Discount',
      gross: 'Gross',
      number: 'Number',
      name: 'Name',

      /** HELP PAGE BEGIN */
      generalTitle: 'What is Alideda?',
      general: 'Alideda is Viennas most powerful Free Wi-Fi Network Marketing tool. We offer our clients great Marketing opportunity. Marketing features which will make your guests remember your brand.<br><br> Best of all is Direct Marketing Campaigns (SMS/Email/Viber) using contact data which is provided by your users. That is great chance to contact them, send them Birthday Gifts, Discounts or call them on your new event.<br><br> It is simple. Werbung(Advertisement) + Wi-Fi = Alideda.',
      helpFAQ: `Help - FAQ`,
      helpFAQSub: `Frequently asked questions and answers`,
      advertisingTitle: 'How can I advertise on Alideda?',
      advertising: 'First option ist Wi-Fi Hotspot Advertising. You can simply put your best photos and videos into your Wi-Fi Hotspot Posts. Everyone who join your Free-WLAN will see your Advertisement and enjoy their benefit. This will suprise your users who use our Alideda Wi-Fi. <br><br> Second option ist Direct Messaging Marketing, via SMS, Email or Viber. Everyone who used your Wi-Fi has been registered. You have access to their contact data and can use it for direct and personal messages. This will remind your users on your business, and make them love your brand. <br><br> Third options is our Alideda Marketing Campaign. Here you can boost your advertisement in all other Alideda Hotspots in country. Let other people see your Posts on others Wi-Fi Network and increase number of new guests. This will bring you more new guests and promote your brand.',
      whatShouldIDo: `What should I do when I something don't understand`,
      whatShouldIDoText: `<p> In this situation you can search on this page(FAQ) for answered questions. Here are the most frequented  problems and solutions. </p><p> We offer also Tutorial Page. Here in Videos have we everything explained and prepared for you that you  can easy understand and use your best Marketing Tool.  <br>  <n-button disabled> Cooming Soon </n-button></p><p> In worst case, if Tutorials and FAQ(Info) Page didn't help, please feel free to contact us. We are ready  to solve your problem in few moments.</p>`,
      loginControlPanel: 'How can I login into Alideda Control Panel?',
      loginControlPanelText: `Simply go to alideda.com and click on Sign In Button. Provide your username and password, and there you are. If you have forgotten your password, you can simply reset it on Forgot Password? You will receive the reset link per Email.`,
      changePasswordHelp: 'How can I change my password?',
      changePasswordHelpText: `You can change your login password in account page, here in admin panel. Just repeat your password 2 times and it is changed.`,
      costsAlideda: 'How much does Alideda cost?',
      costsAlidedaText: `Depending on the package you choose for your WLAN Alideda Hotspot, there are many possible prices. Basic monthly invoice will depend on your WLAN Hotspot features. It goes from 49e to 499e per Month. There are no extra costs. <br><br> You need to buy more credit for Campaign Advertising which prices are: single SMS about 0.07€, and single Email about 0.01€. <br><br> Our Marketing Campaigns will left you breathless, because they boost your Advertisement on every Alideda hotspot in country. This Campaigns are Interaction based, and costs depends on your target and amount of interactions(per view, click or like up to 0.07€). <br> However, Alideda is very cheap and affordable for any favorite Brand-new-business. `,
      discountAlideda: 'Can I get special discount and prices?',
      discountAlidedaText: `Yes, of course. For better prices, bigger amount of credit, or much more Campaign Sessions for example, please feel free to contact us. We will make you an offer you can't refuse :)<br><br> Our Tip is also to follow our Price Wizard and Tips, because there are some special periods in year, or just special days as Black Friday, New Year etc. when we offer special prices for Marketing credit.`,
      advertisementAlidedaWebsite: `How much costs advertisement on Alideda's website?`,
      advertisementAlidedaWebsiteText: `You as Alideda Company have one GRATIS Advertisement on Alideda website. Otherwise it cost 200 Euro pro Advertisement.There you provide some discounts for Alideda users or just promote your business with some nice photos and text. For changing this Advertisement please contact us or send changes as email at info@alideda.com or use our contact service.`,
      howCampaignWorksTitle: `How does Campaign Marketing works?`,
      howCampaignWorksText: `Alideda Campaign Marketing is the best way to promote your business very wide and deep direct to new users and become a popular brand. Your Advertisement could be directly placed as promotion at every Alideda hotspot - this will cost pro interaction(1 view = 0.03€) and click(1 click = 0.05€) or like(1 like = 0.07€).`,
      monthlyFeeTitle: `I have bigger monthly fee then some business. Why?`,
      monthlyFeeText: `Alideda has full option for individual Wi-Fi Hotspot Features, and also possibility to make individual contract. Monthly fee depends on the hardware amount, first one-time pay installation, Hotspot Features, contract length etc. If you want to change your monthly fee, please feel free to contact us, we can change contract as you wish. <b>There is also an option to become to 50% discount on monthly fee, while recommending our services to someone else.</b> Simply, we appreciate our loyalty clients.\`"></div>`,
      featuresDashboardHelp: `What features has my Dashboard Control Panel?`,
      featuresDashboardHelpText: `Our powerful and mobile friendly Dashboard Control Panel will help you to change some Basic Wi-Fi Advertisement as Texts, Photos etc. Also some basic Configuration as Internet Connection Authorization Time, Internet Speed Limit, Number of connected users etc. <br><br> You can follow your Daily Wi-Fi Connection Chart and some other statistics and analytics as Users Countries, Users Phones/Emails etc. Our Statistics will make you prepared for the best and the most frequent days in year. You will always be one step ahead of time.With the help of our Dashboard Control Panel you can contact your Users via SMS or Email. Simply call your Users on Event, send them discount coupons or wish them happy birthday etc. <br><br> Advertising on other Alideda hotspots is our special feature that you can setup in few steps by boosting your posts. <br> Rich and powerful Statistics, Online credit buying for Direct Message Marketing, FAQ Page, Changing Wi-Fi Features and whole Package, all clients preview and Boosting Advertisements across Alideda hotspots are small part of our powerful Dashboard Control Panel.`,
      dashboardProblem:`I have some problems with Admin Panel. What now?`,
      dashboardProblemText:`First thing you can do is to delete all cached Files in your browser. Then reload a page. Another thing you can do is to logout and login again.If that is some big issue, please contact support via live chat or contact form.Our FAQ(Help) or Tutorial Page may also help you solve the problem. It can take you only a few moments.`,
      statisticsHelp: `Statistics`,
      statisticsHelpText: `Here are the most important statistics and analytics of your Wi-Fi such as monthly, daily and weekly connection charts.There are couple of tabs which show how much users are online, total number of spash page popup, number of different users who joined your Alideda Wi-Fi Network and total earned money on our platform by allowing others to place their posts on your Advertising space.Charts can be very useful, for planning your season and prices or for seeing which days/months are the most frequent and accordingly plan your personal.`,
      advertisingHelp: `Advertisements`,
      advertisingHelpText: `On this page you can create new advertisements or just edit existing one. For every advertisement you can choose one or more medias, one title to 150 characters, one text to 300 characters and up to 5 tags. When you created your Ad it will appear only on your own Hotspot, but wait, you can boost on every other splash page in country by starting new marketing campaign.`,
      galleryHelp:`Gallery`,
      galleryHelpText:`For every advertisement you will need some extra content. You can upload it here. Please note that we will crop your pictures by maximal ratio 1:1, so your portrait pictures may not be properly cropped. Usage of landscape pictures in ratio of 4:3 is our recommendation for best user experience.`,
      configurationHelp:`Configuration`,
      configurationHelpText:`This is the page for basic configuration of Alideda Hotspot such as Internet Authorization Time, login options, login priority and landing page, which will be visited after connection.`,
      messageServiceHelp:`Message Service`,
      messageServiceHelpText:`This page is the most important page if you want to feel real power of Alideda direct SMS/Email Marketing. In four simple steps you can type your SMS/Email and with our filter choose best User group that fit to your needs.Cost of sending this message will automatically changed as you change your Filter and number of users. Cost will be shown in Euros.<br><br>Filter features<br> 1. Message Type - Choose if you want to send SMS Messages or Email. Just right you can see how many users are available for that type of message.<br> 2. Countries - Where your users come from. Next to every country is number of users from there and available for above selected type of message.<br> 3. Age Range - Choose age group you want to send message to. By default is set from 18 to 60 years. Changing age range users number can be very reduced.<br> 4. Gender - By default is set to both genders. If you want to send special message only for one gender, for example Mother's or Father's day etc.<br> 5. Registration time - When did you user register on your Wi-Fi Hotspot. Maybe you want to send message only to new or old users. You can choose also special range. By default is set from begin to today.<br> 6. Birthday time - Your users are having their favorite day of year soon? Send them some birthday offers or just wish them happy birthday.<br> 7. Number of visit - Here can you choose your loyalty users and send them discounts or even users who have less then 5 times connected what mean they are not so frequent and they can be also reminded on you with some nice message.`,
      creditsHelp:`Credit`,
      creditsHelpText:`On this page will you buy your credit for SMS/Email or Campaign Marketing. In 3 simple steps you can choose token amount, choose a payment type and preview and print your bill.You can buy token in three types of payment. Credit/Debit Card, Paypal or Sofort. It is very important to print your bill for your accounting. However you can find it anytime on Dashboard > Invoices.`,
      invoicesHelp:`Invoices`,
      invoicesHelpText:`This is a simply page where you can find all your monthly fees and bills you made on Alideda platform. These credit are used for every purchase on our platform and they never expire. You can also exchange credit for real money if you wish, just contact us.`,
      otherServicesHelp:`Other Alideda Services`,
      otherServicesHelpText:`We could know each other maybe little better. Here are some of our other services we provide. All this features are in special discounts just for our loyal companies. We are proud to have opportunity to introduce ourselves.All IT Services, no matter if hardware or software, we have the best engineers ready for you.<br> <b>Websites, Web Application, Photography and Design </b> are just a small part of what we can.`,
      /** HELP PAGE END */

      sms: 'SMS',
      first_name: 'Name',
      email: 'Email',
      price_per_message: 'Price per message: 0.0{0}€',
      whatsapp: 'WhatsApp',
      viber: 'Viber',
      messenger: 'Facebook Messenger',
      tripadvisor: 'TripAdvisor',
      popup: 'Pop-up',
      direct: 'Direct',
      edit: 'Edit',
      add: 'Add',
      saved: 'Saved.',
      save: 'Save',
      edit_company_profile: 'Edit your company data',
      address: 'Address',
      company: 'Company',
      companies: 'Companies',
      phone: 'Phone',
      emailOrUsername: 'Email / Username',
      username: 'Username',
      password: 'Password',
      current_password: 'Current password',
      city: 'City',
      country: 'Country',
      postal_code: 'Postal Code',
      about_company: 'About Company',
      about_company_placeholder: 'Description of the company',
      short_description: 'Slogan',
      short_description_p: 'Slogan - Message that appears unter the company name',
      update_profile: 'Update Profile',
      new_guests_per_month: 'New Guests per Month',
      search: 'Search...',
      blocked: 'Blocked',
      type_message: 'Type your message',
      previous: 'Previous',
      package_title: 'Pick the best Wi-Fi Marketing package for you',
      up_to: 'Up to',
      guest_login: 'Guest Login',
      choose_package: 'Choose Package',
      package_success_1: 'Successfully requested package.',
      package_success_2: 'Our team will review your upgrade request and boost your marketing power as fast as possible. If there are some issues, we will contact you. Thanks for upgrading package. :)',
      package_error_1: 'Sorry, your upgrade request was not sent.',
      package_error_2: 'Something went wrong, please contact support at support@alideda.com.',
      contact_us: 'Contact us',
      contact_form: 'Contact Form',
      send_message: 'Send Message',
      message_start: 'Dear Alideda Team, I have one simple question for you:',
      send_message_success_1: 'Successfully sent message.',
      send_message_success_2: 'Our team will review your message and execute it in wanted time. If there are some issues, we will contact you. Thanks for using our contact service. :)',
      send_message_error_1: 'Sorry, your message was not sent.',
      send_message_error_2: 'Something went wrong, please contact support at support@alideda.com.',
      select_recaptcha: 'Please select Recaptcha.',
      verify_success: 'Verification successful. Please login now.',
      success_reset: 'Successfully changed password.',
      password_not_same: 'Passwords not same.',
      password_too_short: 'Password too short.',
      check_your_inbox: 'Check your inbox',
      create_new: 'Create new',
      manufacturer: 'Manufacturer',
      template: 'Template',
      create_new_template: 'Create new {0} Template',
      template_preview: 'Template preview',
      select_template: 'Select Message Template',
      message_template: 'Message Template',
      message_template_desc: 'Create your own reusable message template',
      create_template_success: 'Successfully created template.',
      pick_from_gallery: 'Pick Photo from Gallery',
      button_text: 'Button Text',
      button_link: 'Button Link',
      button_text_color: 'Button Text Color',
      button_bg_color: 'Button Background Color',
      footer_text: 'Footer Text',

      finish_bulk1: 'You are one step from sending bulk message.',
      finish_bulk2: 'Please choose the estimated time for executing this template.',
      bulk_requests: 'Bulk Requests',
      select_date_time: 'Select date and time',
      message_type: 'Message type',
      subject: 'Subject',
      view: 'View',
      filter: 'Filter',
      countries: 'Countries',
      languages: 'Languages',
      visits: 'Visits',
      registration_time: 'Registration time',
      execution: 'Execution',
      scheduled_time: 'Scheduled time',
      requested_time: 'Requested time',
      price_estimated: 'Price estimated',
      price_real: 'Price real',
      sent_at: 'Sent at',
      not_executed_yet: 'Not executed yet',
      close: 'Close',
      unknown: 'Unknown',
      registered_via: 'Registered via',
      see_you_soon: 'See you soon',
      pick_template: 'Please pick template to send',
      choose_time: 'Please choose execution time',
      all_checked: 'All checked',
      templateNoticeSMS: '<span style="color: red;">IMPORTANT</span> <br> <br>\n' +
        'Make sure you have your business name in the end,<br>\n' +
        'so that recipients know that message is from you. <br><br>\n' +
        'Use "%recipient.name%" for recipient name variable in your message. <br><br>\n' +
        'SMS has 160 characters, but 25 are reserved for \'unsubscribe\' link. <br>\n' +
        'If you use special characters or emoji, the length will be reduced.',
      name_your_template: 'Name your template',
      message_short: 'Message too short.',
      subject_short: 'Message too short.',
      message_long: 'Message too long.',
      subject_long: 'Subject too long.',
      html_short: 'HTML too short.',
      text_short: 'Text too short.',
      wrong_birthday_range: 'Wrong birthday range',
      wrong_registration_range: 'Wrong registration date range',
      wrong_url: 'Wrong url',
      no_users_for_this_filter: 'No users found for this filter',
      name_template: 'Please name your template',
      char_left: 'Characters left',
      auto_google_reviews: 'Automatic Google Reviews sent 2h after guest has registered',
      for_example: 'For example',
      website: 'Website',
      select_language: 'Select Language',
      select_country: 'Select Country',
      company_type: 'Company Type',
      welcome_on_board: 'Welcome on board. <i class="now-ui-icons emoticons_satisfied"></i> <br>\n' +
        'Please fill out your company data below. <br>\n' +
        'Our team will review your company and approve access in very short time. <br>\n' +
        'Thank you for using our marketing platform.',
      per_page: 'Per page',
      every_day: 'Every day',
      date_time: 'Day time',
      day_time: 'Day time',
      whole_day: 'Whole day',
      time: 'Time',
      number_of_client: 'Number of clients',
      total_investigated: 'Total investigated clients',
      official_name: 'Official company name',
      credit_card: 'Credit Card',
      credit_card_name: 'Name on card',
      credit_card_number: 'Card number',
      credit_card_expire: 'Card expiration (MM/YY)',
      credit_card_code: 'Card security code',
      setup_net: 'Setup Net',
      setup_gross: 'Setup Gross',
      monthly_net: 'Monthly Net',
      monthly_gross: 'Monthly Gross',
      billing_start: 'Billing Start',
      billing_end: 'Billing End',
      cash: 'Cash',
      sepa: 'SEPA - Bank withdraw',
      bank: 'Bank payment',
      billing: 'Billing',
      free: 'Free',
      new_client: 'New Client',
      investigate_potential_client: 'Investigate potential client',
      select_investigate_client: 'Select investigated company',
      owner: 'Owner',
      enter_owner_data: 'Enter Owner Data',
      enter_name: 'Enter name',
      enter_phone: 'Enter phone',
      enter_company_data: 'Enter company data',
      technical_investigation: 'Technical Investigation',
      provider: 'Provider',
      rooms: 'Rooms',
      square_meter: 'Square Meters',
      comment: 'Comment',
      select_devices: 'Select Devices',

      rating: 'Rating',
      reviews: 'Reviews',
      total_reviews: 'Total Reviews',
      review_text: 'Review Text',
      total_review_scans: 'Google Review via QR or Link',
      review_average: 'Average rating',
      current_google_rating: 'Current Google Rating',

      widget: 'Website Widget',
      widget_title: 'Google Rating | Website Widget',
      widget_p1: 'Copy the following script and paste it into your website',
      widget_p2: 'Your widget is currently configured for',
      widget_p3: 'If you have any questions regarding integration',


      are_you_sure: 'Are you sure?',
      cannot_undo: 'You cannot undo this action.',
      yes_proceed: 'Yes, proceed.',
      no_cancel: 'No, cancel.',

      copy: 'Copy',
      copied: 'Copied',
      color: 'Color',
      background: 'Background',
      download: 'Download',

      review_statistics: 'Reviews Statistics',
      front_side: 'Front side',
      back_side: 'Back side',
      front_side_p: 'We value your feedback',
      front_side_gift_p: 'Wanna surprise?',
      back_side_gift_p: 'Grab your gift',
      front_side_covid_p: 'COVID-19 Guest registration \n\n Table number: _________',
      back_side_covid_p: 'Register now using\n\n table number: ________',
      scan_or_visit: 'Scan QR-Code or visit',
      qr_or_link: 'Via QR-Code or Link',
      rate_on_google: 'Rate us on Google',
      paper_form: 'Papier Template For Guest Registration',

      gifts: 'Gifts',
      gift: 'Gift',
      table_poster_gift: 'Gift-concept Table poster',
      table_poster_covid: 'Table poster for COVID-19 registration',
      gift_statistics: 'Gift Statistics',
      total_gift_scans: 'Total Gift QR-Scans',
      total_gift_redeems: 'Total Gift-Redeems',
      total_gift_sent: 'Total sent gifts',
      total_menu_openings: 'Total menu openings',
      powered_by: 'powered by',

      hotspot_ads: 'Hotspot with advertisements',
      redirection: 'Redirection to promotional website',
      registration: 'Guests Registration',
      support: 'Support',
      working_days: 'Working days',
      newsletter: 'Newsletter Service',
      google_review: 'Google Review Automation',
      sponsorship: 'Exclusive Sponsorship',
      third_party_ad: 'Third-party Advertising',

      // Covid
      guest_checkin: 'EVID.AT - Guest registration',
    }),




    new MLanguage('German').create({
      english: 'Englisch',
      german: 'Deutsch',
      serbian: 'Serbisch',
      copyright: 'Urheberrecht',

      /** HELP PAGE BEGIN */
      generalTitle: 'Was ist eigentlich Alideda?',
      general: 'Alideda ist Wiens beliebtestes Free-WLAN-Netzwerk. Wir haben mehr als 1000 Wi-Fi-Hotspots und bieten unseren Unternehmen großartige Marketing-Möglichkeiten.<br><br> Das Beste von allem ist SMS/Email Marketing für Ihre Benutzer. Das ist eine großartige Chance, um Ihre Nutzer zu kontaktieren, ihnen Geburtstagsgeschenke, Rabatte zu schicken oder einfach auf Ihre neue Veranstaltung einzuladen. <br><br> Einfach: Werbung(Advertisement) + Wi-Fi = Alideda',
      helpFAQ: `Hilfe - FAQ`,
      helpFAQSub: `Häufig gestellte Fragen und Antworten`,
      advertisingTitle: 'Wie kann ich mich am Alideda werben?',
      advertising: 'Erste Option ist Wi-Fi Hotspot Advertising. Sie können einfach Ihre beste Photos und Videos auf Ihre Wi-Fi Hotspot einstellen. Jeder wer ist mit Ihren Wi-Fi verbunden, kann Ihre Werbungen sehen und genießen ihre Vorteile. Das kann positiv Ihre Kunden überraschen.<br><br>Zweite Option ist Direct SMS/Email Marketing. Jeder wer ist mit Ihren Wi-Fi verbunden, ist automatisch registriert. Sie haben ihres/seines Telefonnummer/Email(oder beide) und können Sie sie nutzen, um persönliche Nachrichten zu schicken. Das wird Ihre Kunden an Ihres Business erinnern.<br><br>Dritte Option ist unserer "Alideda Marketing Campaign". Hier können Sie Ihre Werbungen in allen unseren Hotspots anzeigen. Lassen Sie anderen Menschen Ihre Werbungen an anderen Hotspots in der Stadt sehen. Das wird Ihnen mehr neuen Kunden bringen und Sie zu einer besonderen Marke machen.',
      whatShouldIDo: 'Was soll ich machen, wenn ich etwas nicht verstehe?',
      whatShouldIDoText: `<p> In dieser Situation können Sie auf dieser Seite (FAQ) nach beantworteten Fragen suchen. Hier sind die häufigsten Probleme und Lösungen. </p> <p> Wir bieten auch Tutorial-Seite an. Hier in Videos haben wir alles für Sie erklärt und vorbereitet, dass Sie Ihr bestes Marketing Tool einfach verstehen und verwenden können. <br> <n-button disabled> In Kürze </n-button> </p> <p> Wenn die Seite Tutorials und FAQ (Info) im schlimmsten Fall nicht geholfen hat, kannst du uns gerne kontaktieren. Wir sind bereit, Ihr Problem in wenigen Augenblicken zu lösen. </p>`,
      loginControlPanel: 'Wie kann ich mich einloggen?',
      loginControlPanelText: `Gehen Sie einfach auf alideda.com und klicken Sie auf Anmelden. Geben Sie Ihren Benutzernamen und Ihr Passwort ein und Sie sind da. Wenn Sie Ihr Passwort vergessen haben, können Sie es einfach auf Passwort vergessen zurücksetzen. Sie erhalten den Link per E-Mail zurücksetzen.`,
      changePasswordHelp: 'Wie kann ich mein Passwort verändern?',
      changePasswordHelpText: `Sie können Ihr Login-Passwort auf der Account-Seite hier im Admin-Bereich ändern. Wiederhole einfach Ihr Passwort 2 mal und es wird geändert. <br>`,
      costsAlideda: 'Wie viel Alideda kostet?',
      costsAlidedaText: `Je nach Paket, das Sie für Ihren WLAN Alideda Hotspot auswählen, gibt es verschiedene Preise. Die monatliche Grundrechnung hängt von den Funktionen Ihrer WLAN Hotspot ab. Es geht von 49e bis 499e pro Monat. Es gibt keine zusätzlichen Kosten. <br> <br> Für Newsletter müssen Sie Guthaben kaufen, deren Preise sind: einzelne SMS etwa 0,07€ und einzelne Email etwa 0,01€. <br> <br> Unsere Marketingkampagnen werden Sie atemlos lassen, weil sie Ihre Werbung an jedem Alideda-Hotspot im Land platzieren. Diese Kampagnen sind interaktionsbasierte und die Kosten hängen von Ihrem Ziel und der Anzahl der Interaktionen ab (pro Ansicht können Sie bis zu 0.07€ zahlen).`,
      discountAlideda: 'Kann ich einen speziellen Rabatt bekommen?',
      discountAlidedaText: `Ja natürlich. Für bessere Preise, größere Mengen an Credit oder viel mehr Campaign Sessions, kontaktieren Sie uns bitte. Wir machen Ihnen ein Angebot, das Sie nicht ablehnen können. <br> <br> Unser Tipp ist auch, unseren Preis-Assistenten und Tipps zu beachten, denn es gibt einige spezielle Perioden im Jahr oder nur besondere Tage wie Black Friday, New Year usw., wenn wir Sonderpreise für Marketing-Credit anbieten.`,
      advertisementAlidedaWebsite: `Wie viel kostet Werbung auf der 'Alideda' Webseite?`,
      advertisementAlidedaWebsiteText: `Sie als Alideda Company haben eine GRATIS Werbung auf der Alideda Website. Ansonsten kostet es 200 Euro pro Advertisement. Dort bieten Sie einige Rabatte für Alideda-Nutzer an oder werben Sie einfach mit schönen Fotos und Texten für Ihr Geschäft. Um diese Werbung zu ändern, kontaktieren Sie uns bitte oder senden Sie uns Ihre Änderungen per E-Mail an info@alideda.com oder nutzen Sie unseren Kontaktservice. `,
      howCampaignWorksTitle: `Wie funktioniert Kampagnen-Marketing?`,
      howCampaignWorksText: `Alideda Campaign Marketing ist der beste Weg, um Ihr Unternehmen sehr breit und tief direkt an neue Benutzer zu fördern und eine beliebte Marke zu werden. Deine Werbung könnte direkt als Werbung an jedem Alideda Hotspot platziert werden - das kostet pro Interaktion (1 view = 0,03€) und Klick (1 Klick = 0,05€) oder ähnliches (1 like = 0,07€).`,
      monthlyFeeTitle: `Ich habe eine größere monatliche Gebühr als ein Geschäft. Warum?`,
      monthlyFeeText: `Alideda hat volle Wahlmöglichkeit für individuelle Wi-Fi Hotspot Features, sowie die Möglichkeit individuelle Verträge abzuschließen. Die monatliche Gebühr hängt von der Hardware-Menge, der ersten einmaligen Bezahl-Installation, den Hotspot-Funktionen, der Vertragsdauer usw. ab. Wenn Sie Ihre monatliche Gebühr ändern möchten, wenden Sie sich bitte an uns, wir können den Vertrag ändern, wie Sie es wünschen. <b> Es gibt auch eine Option, um 50% Rabatt auf die monatliche Gebühr zu bekommen, während wir unsere Dienstleistungen an jemand anderen weiterempfehlen. </b> Einfach, wir schätzen unsere Treue-Kunden.> </div>`,
      featuresDashboardHelp: `Welche Funktionen hat mein Dashboard Control Panel?`,
      featuresDashboardHelpText: `Unser leistungsstarkes und mobiles Dashboard Control Panel wird Ihnen helfen, einige grundlegende Wi-Fi-Werbung als Texte, Fotos usw. zu ändern. Auch einige grundlegende Konfiguration wie Internet Connection Authorization Time, Internet Speed ​​Limit, Anzahl der angeschlossenen Benutzer etc. <br> <br > Sie können Ihre tägliche Wi-Fi-Verbindungstabelle und einige andere Statistiken und Analysen wie Benutzer Länder, Benutzer Telefone / E-Mails etc. verfolgen. Unsere Statistiken machen Sie auf die besten und häufigsten Tage im Jahr vorbereitet. Sie werden der Zeit immer einen Schritt voraus sein. Mit Hilfe unseres Dashboard Control Panels können Sie Ihre Benutzer per SMS oder E-Mail kontaktieren. Rufen Sie einfach Ihre User per Event an, schicken Sie ihnen Rabattcoupons oder wünschen Sie alles Gute zum Geburtstag etc. <br> <br> Werbung auf anderen Alideda Hotspots ist unsere Besonderheit, die Sie in wenigen Schritten durch die Steigerung Ihrer Anzeigen einrichten können. <br> Reiche und leistungsstarke Statistiken, Online-Kauf von Guthaben für Direct Message Marketing, FAQ-Seite, Ändern der WLAN-Funktionen und des gesamten Pakets, Vorschau aller Kunden und Werbebotschaften über Alideda-Hotspots sind nur ein kleiner Teil unseres leistungsstarken Dashboard Control Panel.`,
      dashboardProblem:`Ich habe einige Probleme mit dem Admin-Panel. Was jetzt?`,
      dashboardProblemText:`Als erstes können Sie alle zwischengespeicherten Dateien in Ihrem Browser löschen. Laden Sie dann eine Seite neu. Eine andere Sache, die Sie tun können, ist Abmelden und erneut anmelden. Wenn das ein großes Problem ist, kontaktieren Sie bitte den Support per Live-Chat oder Kontaktformular. Unsere FAQ (Hilfe) oder Tutorial Seite kann Ihnen auch helfen, das Problem zu lösen. Es kann nur wenige Augenblicke dauern.`,
      statisticsHelp: `Statistiken`,
      statisticsHelpText: `Hier sind die wichtigsten Statistiken und Analysen Ihrer Wi-Fi wie z. B. monatliche, tägliche und wöchentliche Verbindung Charts. Es gibt einige Tabs, die zeigen, wie viele Benutzer online sind, Gesamtzahl der Spash-Seite Popup, Anzahl der verschiedenen Benutzer, die Ihr beigetreten Alideda Wi-Fi Network und verdiente Geld auf unserer Plattform, indem Sie anderen erlauben, ihre Anzeigen auf Ihrer Werbefläche zu platzieren. Charts können sehr nützlich sein, um Ihre Saison und Preise zu planen oder um zu sehen, welche Tage / Monate am häufigsten sind und dementsprechend planen dein persönliches.`,
      advertisingHelp: `Werbungen`,
      advertisingHelpText: `Auf dieser Seite können Sie neue Inserate erstellen oder bestehende bearbeiten. Für jede Werbung können Sie ein oder mehrere Medien wählen, einen Titel auf 150 Zeichen, einen Text auf 300 Zeichen und bis zu 5 Tags. Wenn Sie Ihre Anzeige erstellt haben, erscheint sie nur auf Ihrer eigenen Hotspot. Aber warten Sie, Sie können auf jeder anderen Hotspot im Land mit neuen Marketingkampagnen beginnen. `,
      galleryHelp:`Galerie`,
      galleryHelpText:`Für jede Werbung benötigen Sie zusätzliche Inhalte. Sie können es hier hochladen. Bitte beachten Sie, dass wir Ihre Bilder im maximalen Verhältnis 1: 1 zuschneiden, so dass Ihre Porträtbilder möglicherweise nicht richtig beschnitten werden. Die Verwendung von Landschaftsbildern im Verhältnis 4: 3 ist unsere Empfehlung für beste User Experience. `,
      configurationHelp:`Konfiguration`,
      configurationHelpText:`Dies ist die Seite für die Grundkonfiguration der Alideda Hotspot, wie z.B. die Internetzeit, Anmeldeoptionen, Anmeldepriorität und Zielseite, die nach der Verbindung besucht werden. `,
      messageServiceHelp:`Nachrichtendienst`,
      messageServiceHelpText:`Diese Seite ist die wichtigste Seite, wenn Sie echte Kraft von Alideda Direkt SMS / Email Marketing spüren möchten. In vier einfachen Schritten können Sie Ihre SMS / E-Mail eingeben und mit unserem Filter die beste Benutzergruppe auswählen, die Ihren Bedürfnissen entspricht. Die Kosten für das Senden dieser Nachricht werden automatisch geändert, wenn Sie Ihren Filter und die Anzahl der Benutzer ändern. <br> <br> Filterfunktionen <br> 1. Nachrichtentyp - Wählen Sie, ob Sie SMS oder E-Mail senden möchten. Genau richtig können Sie sehen, wie viele Benutzer für diese Art von Nachricht verfügbar sind. <br> 2. Länder - Woher kommen Ihre Benutzer? Neben jedem Land ist die Anzahl der Benutzer von dort und für den oben ausgewählten Nachrichtentyp verfügbar. <br> 3. Altersbereich - Wählen Sie die Altersgruppe aus, zu der Sie eine Nachricht senden möchten. Standardmäßig ist zwischen 18 und 60 Jahren eingestellt. Ändern der Altersbereich Benutzerzahl kann sehr reduziert werden. <br> 4. Geschlecht - Standardmäßig ist auf beide Geschlechter eingestellt. Wenn Sie eine spezielle Nachricht nur für ein Geschlecht senden möchten, zum Beispiel Mutter- oder Vatertag usw. 5. Anmeldezeit - Wann haben Sie sich bei Ihrem WLAN-Hotspot angemeldet? Vielleicht möchten Sie eine Nachricht nur an neue oder alte Benutzer senden. Sie können auch einen speziellen Bereich wählen. Standardmäßig wird von Beginn bis heute eingestellt. <br> 6. Geburtstagszeit - Ihre Nutzer haben bald ihren Lieblingstag im Jahr? Schicke ihnen einige Geburtstagsangebote oder wünsche ihnen alles Gute zum Geburtstag. <br> 7. Anzahl der Besuche - Hier kannst du deine Loyalitätsnutzer auswählen und ihnen Rabatte schicken oder sogar Nutzer, die weniger als 5 Mal miteinander verbunden sind, was bedeutet, dass sie nicht so häufig sind und Sie können auch mit einer netten Nachricht an dich erinnert werden. `,
      creditsHelp:`Credit`,
      creditsHelpText:`Auf dieser Seite kaufen Sie Ihr Guthaben für SMS / E-Mail Marketing. In 3 einfachen Schritten können Sie den Credit-Betrag wählen, eine Zahlungsart auswählen und Ihre Rechnung in der Vorschau anzeigen und ausdrucken. Sie können Guthaben in drei Zahlungsarten kaufen. Credit-/Debitkarte, Paypal oder Sofort. Es ist sehr wichtig, Ihre Rechnung für Ihre Buchhaltung zu drucken. Sie können es jedoch jederzeit auf Dashboard> Rechnungen finden.`,
      invoicesHelp:`Rechnungen`,
      invoicesHelpText:`Dies ist eine einfache Seite, wo Sie alle Ihre monatlichen Gebühren und alle Rechnungen finden. Dieses Guthaben werden für jeden Einkauf auf unserer Plattform verwendet und verfallen nie. Sie können auch Ihr Guthaben gegen echtes Geld tauschen, wenn Sie möchten, kontaktieren Sie uns einfach.`,
      otherServicesHelp:`Andere Alideda Dienstleistungen`,
      otherServicesHelpText:`Wir konnten uns vielleicht ein bisschen besser kennenlernen. Hier sind einige unserer anderen Dienstleistungen, die wir anbieten. All diese Funktionen sind in speziellen Rabatten nur für unsere treuen Unternehmen. Wir sind stolz, die Gelegenheit zu haben, uns vorzustellen. Alle IT-Dienstleistungen, egal ob Hardware oder Software, wir haben die besten Ingenieure für Sie bereit. <br> <b> Websites, Web-Anwendung, Fotografie und Design </b> sind nur ein kleiner Teil dessen, was wir können.`,
      /** HELP PAGE END */

      messanger: 'Facebook Messanger',
      sms: 'SMS',
      first_name: 'Name',
      email: 'Email',
      price_per_message: 'Preis/Nachricht: 0.0{0}€',
      whatsapp: 'WhatsApp',
      viber: 'Viber',
      messenger: 'Facebook Messenger',
      tripadvisor: 'TripAdvisor',
      popup: 'Pop-up',
      direct: 'Direkt',
      edit: 'Ändern',
      add: 'Hinzufügen',
      log_out: 'Ausloggen',
      language: 'Sprache',
      account: 'Profil',
      register: 'Registrieren',
      login: 'Anmeldung',
      forgot_password: 'Passwort vergessen',
      reset_password: 'Passwort zurücksetzen',
      new_password: 'Neues Password',
      repeat_password: 'Passwort wiederholen',
      change_password: 'Passwort ändern',
      verify_account: 'Konto Verifizieren',
      enter_email: 'Email eingeben',
      already_have_account: 'Haben Sie bereits ein Konto?',
      boost_title: 'Deine Werbung für Boost',
      monthly_campaign: 'Monatliche Kampagne',
      one_time_campaign: 'One-time Kampagne',
      monthly_campaign_settings: 'Monatliche Kampagne Einstellungen',
      one_time_campaign_settings: 'One-time Kampagne Einstellungen',
      campaign_investments: 'Kampagne Investitionen:',
      sorry_more_credits: 'Tut mir leid, Sie müssen mehr Guthaben für diese Kampagne kaufen. Ihr auktelles Guthaben: {credit}€',
      buy_more_credits: 'Credit kaufen',
      per_view_price: 'Pro View: 0.03€',
      per_click_price: 'Pro Click: 0.05€',
      per_like_price: 'Pro Like: 0.07€',
      prices: 'Prices',
      campaign_type: 'Typ der Kampagne',
      register_title1: 'Marketing automatisieren',
      register_desc1: 'Lassen Sie Ihr Wi-Fi Ihr Marketing für Sie erledigen.',
      register_title2: 'Kundendaten sammeln',
      register_desc2: 'Sammle und analysiere detaillierte Gästedaten.',
      register_title3: 'Direktmarketing',
      register_desc3: 'Bleiben Sie über unseren Newsletter mit Ihren Gästen in Kontakt.',
      locations: 'Lokationen: ',
      wifi_posts: 'WiFi Werbungen',
      wifi_statistics: 'WiFi-Statistik',
      statistics: 'Statistik',
      clients: 'Kunden',
      devices: 'Geräte',
      aps: 'Access Points',
      urls: 'URL-Kürzung',
      accounts: 'Kontos',
      guests: 'Gäste',
      message_service: 'Nachrichtendienst',
      billboard_posts: 'Billboard Werbungen',
      indoor_billboards: 'Werbescreens',
      invoices: 'Rechnungen',
      invoice: 'Rechnung',
      payment_method: 'Zahlung',
      product: 'Produkt',
      net: 'Netto',
      vat: 'USt',
      refresh_hotspot: 'Hotspot Aktualisieren',
      configuration: 'Konfiguration',
      package: 'Paket',
      contact: 'Kontakt',
      help: 'Hilfe',
      enter: 'Eingeben',
      create_new_ad: 'Neue Werbung erstellen',
      enter_description: 'Beschreibung eingeben',
      enter_title: 'Titel eingeben',
      enter_tags_text: 'Tags eingeben - Max 5 - Wählen Sie bestehende für mehr views, oder erstellen Sie ein neu',
      enter_tag: 'Tag erstellen',
      selectMedias: 'Medias auswählen',
      online: 'Online Geräte',
      client: 'Kunde',
      client_statistics: 'Kunden Statistik',
      incl_investigation: 'Inklusive Ersuchungen',
      total_connections: 'Insgesamt Verbindungen',
      average_daily_connections: 'Durchschnittliche Verbindungen täglich',
      total_money_earned: 'Gesamt Geld verdient',
      money_earned_this_month: 'Geld verdient dieses Monat',
      monthly_connections: 'Monatliche Verbindungen',
      today: 'Heute',
      reset_form: 'Form leeren',
      advanced_settings: 'Erweiterte Einstellungen',
      or: 'Oder',
      no: 'Ohne',
      coming_soon: 'Kommt bald.',
      connections: 'Verbindungen',
      last_30_days: 'Frequenz der Verbindungen in letzten 30 Tage',
      last_24_hours: 'Verbindungen in 24 Stunden',
      during_the_day_connections: 'Frequenz der Verbindunden by Stunde groupiert',
      weekly_connections: 'Wochentliche Verbindungen',
      connections_in_one_week: 'Verbindungen in der Woche',
      during_the_week: 'Frequenz der Verbindungen täglich groupiert',
      cancel: 'Schließen',
      gallery: 'Galerie',
      duration_in_sec: 'Dauer in Sekunden',
      enter_duration_in_sec: 'Dauer in Sekunden eintippen',
      select_file: 'Datei auswählen',
      upload_via_external_link: 'Vom externen hochladen',
      upload: 'Hochladen',
      no_file: 'Kein Datei',
      drop_files: 'Drag & Drop Dateien',
      upload_new: 'Neue Media hochladen',
      upload_media_type: 'Wählen Sie den Medientyp vor dem Hochladen',
      cancel_editing_promotion: 'Schließen',
      error: 'Fehler',
      created: 'Erstellt',
      deleted: 'Gelöscht.',
      data_not_valid: 'Daten sind nicht korrekt',
      success: 'Erfolg',
      active: 'Aktiv',
      crop: 'Ausschneiden',
      and: 'Und',
      credits_success_1: 'Guthaben wurde aktualisiert',
      credits_success_2: 'Danke für Ihr Vertrauen!',
      credits_error_1: 'Ihre Zahlung ist fehlgeschlagen.',
      credits_error_2: 'Es wurden keine Gebühren erhoben.',
      payment_type: 'Art der Bezahlung',
      click_checkout: 'Wählen Sie Abschließen für Bezahlung',
      credit: 'Guthaben',
      price: 'Preis',
      amount: 'Menge',
      balance_after_deposit: 'Guthaben nach Einzahlung',
      buy_again: 'Wieder kaufen',
      buy_credits_title: 'Guthaben aufladen',
      choose_amount: 'Wählen Sie Betrag',
      choose_type: 'Wählen Sie Typ',
      payment_option: 'Art der Bezahlung',
      choose: 'Auswählen',
      birthday: 'Geburtstag',
      media: 'Media',
      photo: 'Bild',
      title: 'Titel',
      description: 'Beschreibung',
      from: 'Von',
      to: 'Bis',
      actions: 'Aktionen',
      showing: 'Darstellung von {from} bis {to} von total {total} Einträge',
      type: 'Typ',
      payment: 'Zahlung',
      date: 'Datum',
      total: 'Total',
      status: 'Status',
      discount: 'Rabatt',
      gross: 'Brutto',
      number: 'Nummer',
      name: 'Name',
      saved: 'Gespeichert.',
      save: 'Speichern',
      next: 'Weiter',
      user_filter: 'Benutzerfilter',
      recipients: 'Empfänger',
      campaign_investment: 'Kampagne Investition - ',
      company_filter: 'Firmenfilter',
      age: 'Alter',
      gender: 'Geschlecht',
      both: 'Beide',
      male: 'Male',
      female: 'Female',
      message: 'Nachricht',
      type_sms_150_long: 'Tippen Sie Ihre {0} Symbolen lang SMS ',
      make_email: 'Erstellen Sie Ihre wunderschöne Email. ',
      total_receiving_message: 'Total Empfänger',
      total_costs_message: 'Gesamt Preis für diese Nachricht',
      deposit: 'Einzahlung',
      total_costs: 'Gesamt Preis',
      total_guests: 'Gesamt Gäste',
      current_balance: 'Aktuelles Guthaben',
      remaining_credits: 'Verbleibend Guthaben',
      email_html: 'Email',
      type_email_title: 'Tippen Sie Ihr Email-Titel',
      type_email_text: 'Tippen Sie Ihr Email-Text',
      summary: 'Zusammenfassung',
      campaign: 'Kampagne',
      success_campaign_message_1: 'Erfolgreich erstellte Kampagne.',
      success_campaign_message_2: 'Unser Team wird Ihre Kampagne überprüfen und so schnell wie möglich starten. Wenn es Probleme gibt, werden wir Sie kontaktieren. Danke, dass Sie unseren Kampagnenservice nutzen. :)',
      authorization_time: 'Gäste-WLAN Internetverbindung Zeit | Wert in Minuten',
      promoPage: 'Werbeseite nach Verbindung über Hotspot',
      on: 'Ein',
      off: 'Aus',
      login_priority: 'Priorität der Gast-WLAN-Anmeldeoption | E-Mail oder SMS',
      login_on_visit: 'Login auf Besuch',
      explanation_configuration: 'Nur eigene Werbungen - wenn es ermöglicht ist, Sie können kein Guthaben verdienen wobei Sie anderen Nützer ermöglichen, Ihre Werbefläche zu benutzen',
      date_picker_texts : {
        night: 'Tag',
        nights: 'Tags',
        'day-names': ['Sonn', 'Mon', 'Die', 'Mitt', 'Donn', 'Frei', 'Sam'],
        'check-in': 'Start datum',
        'check-out': 'Ende datum',
        'month-names': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      },
      print: 'Ausdrücken',
      send_on_email: 'Auf Email schicken',
      boost: 'Boost',
      delete: 'Löschen',
      edit_company_profile: 'Verändern Sie die Daten des Unternehemns',
      address: 'Adresse',
      company: 'Unternehmen',
      companies: 'Unternehmen',
      phone: 'Handynummer',
      emailOrUsername: 'Email / Benutzername',
      username: 'Username',
      password: 'Passwort',
      current_password: 'Aktuelles Passwort',
      city: 'Stadt',
      country: 'Staat',
      postal_code: 'Postleitzahl',
      about_company: 'Über Unternehmen',
      about_company_placeholder: 'Beschreibung des Unternehmens',
      short_description: 'Slogan',
      short_description_p: 'Slogan - Nachricht, die unter dem Firmennamen angezeigt wird',
      update_profile: 'Aktualisieren Profil',
      new_guests_per_month: 'Neue Gäste pro Monat',
      search: 'Suche...',
      type_message: 'Tippen Sie Ihre Nachricht',
      finish: 'Abschließen',
      blocked: 'Blockiert',
      previous: 'Züruck',
      package_title: 'Wählen Sie das beste Wi-Fi Marketing Paket für Sie',
      up_to: 'Bis zum',
      guest_login: 'Gäste Login',
      choose_package: 'Wähle Paket',
      package_success_1: 'Erfolgreich angefordertes Paket.',
      package_success_2: 'Unser Team wird Ihre Upgrade-Anfrage prüfen und Ihre Marketing-Power so schnell wie möglich steigern. Wenn es Probleme gibt, werden wir Sie kontaktieren. Danke für das Upgrade des Pakets. :)',
      package_error_1: 'Entschuldigung, Ihre Upgrade-Anfrage wurde nicht gesendet.',
      package_error_2: 'Es ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Support unter support@alideda.com.',
      contact_us: 'Kontaktiere uns',
      contact_form: 'Kontakt Formular',
      send_message: 'Nachricht senden',
      message_start: 'Liebes Alideda Team, ich habe eine einfache Frage an Ihnen:',
      send_message_success_1: 'Nachricht erfolgreich gesendet.',
      send_message_success_2: 'Unser Team wird Ihre Nachricht überprüfen und in der gewünsten Zeit versenden. Wenn es Probleme gibt, werden wir Sie kontaktieren. Danke für die Nutzung unseres Kontaktservice. :)',
      send_message_error_1: 'Entschuldigung, Ihre Nachricht wurde nicht gesendet.',
      send_message_error_2: 'Es ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Support unter support@alideda.com.',
      select_recaptcha: 'Bitte wählen Sie Recaptcha.',
      verify_success: 'Überprüfung erfolgreich. Bitte melde dich jetzt an.',
      success_reset: 'Passwort erfolgreich geändert.',
      password_not_same: 'Passwörter nicht gleich.',
      password_too_short: 'Passwort zu kurz.',
      check_your_inbox: 'Überprüfe dein Inbox',
      create_new: 'Neu erstellen',
      manufacturer: 'Hersteller',
      template: 'Vorlage',
      create_new_template: 'Neue {0} Vorlage Erstellen',
      template_preview: 'Vorlagenvorschau',
      select_template: 'Nachrichtenvorlage auswählen',
      message_template: 'Nachricht Vorlage',
      message_template_desc: 'Erstellen Sie Ihre eigene wiederverwendbare Nachrichtenvorlage',
      create_template_success: 'Vorlage erfolgreich erstellt',
      pick_from_gallery: 'Aus Galerie auswählen',
      button_text: 'Text des Buttons',
      button_link: 'Link des Buttons',
      button_text_color: 'Textfarbe des Buttons',
      button_bg_color: 'Hintergrundfarbe des Buttons',
      footer_text: 'Text des Footers',

      finish_bulk1: "Sie sind nur einen Schritt vom Senden einer Bulk-Nachricht entfernt.",
      finish_bulk2: 'Bitte wählen Sie die voraussichtliche Zeit für die Ausführung dieser Vorlage.',
      bulk_requests: 'Bulk Anfragen',
      select_date_time: 'Datum und Uhrzeit auswählen',
      message_type: 'Nachrichtentyp',
      subject: 'Betreff',
      view: 'View',
      filter: 'Filter',
      countries: 'Länder',
      languages: 'Sprachen',
      visits: "Besuche",
      registration_time: 'Registrierungszeit',
      execution: 'Ausführung',
      scheduled_time: 'Geplante Zeit',
      requested_time: 'Angeforderte Zeit',
      price_estimated: 'Geschätzter Preis',
      price_real: 'Preis real',
      sent_at: 'Gesendet um',
      not_executed_yet: 'Noch nicht ausgeführt',
      close: 'Schließen',
      unknown: 'Unbekannt',
      registered_via: 'Registriert über',
      see_you_soon: 'Bis bald',
      pick_template: 'Bitte Vorlage zum Senden auswählen',
      choose_time: 'Bitte Ausführungszeit wählen',
      all_checked: 'Alle markiert',
      templateNoticeSMS: '<span style = "color: red;"> WICHTIG </ span> <br> <br> \n' +
      'Stellen Sie sicher, dass Sie am Ende Ihren Firmennamen haben, <br> \n' +
      'Damit die Empfänger wissen, dass die Nachricht von Ihnen stammt. <br> <br> \n '+
      'Verwenden Sie "%recipient.name%" als Empfängernamenvariable in Ihrer Nachricht. <br> <br> \n '+
      'SMS hat 160 Zeichen, aber 25 sind für den Link "Abbestellen" reserviert. <br> \n '+
      'Wenn Sie Sonderzeichen oder Emoji verwenden, wird die Länge reduziert.',
      name_your_template: 'Benenne deine Vorlage',
      message_short: 'Nachricht zu kurz.',
      subject_short: 'Nachricht zu kurz.',
      message_long: 'Nachricht zu lang.',
      subject_long: 'Titel zu lang.',
      html_short: 'HTML zu kurz.',
      text_short: 'Text zu kurz.',
      wrong_birthday_range: 'Falscher Geburtstagsbereich',
      wrong_registration_range: 'Falscher Registrierungsdatumbereich',
      wrong_url: 'Falsches URL',
      no_users_for_this_filter: 'Keine Benutzer für diesen Filter gefunden',
      name_template: 'Bitte benenne deine Vorlage',
      char_left: 'Zeichen übrig',
      auto_google_reviews: "Automatische Google-Bewertungen werden 2 Stunden nach der Registrierung des Gasts gesendet",
      for_example: 'Zum Beispiel',
      website: 'Webseite',
      select_language: 'Sprache auswählen',
      select_country: 'Land auswählen',
      company_type: 'Firmentyp',
      welcome_on_board: 'Willkommen an Bord. <i class = "now-ui-icons emoticons_satisfied"> </ i> <br> \ n '+
        'Bitte geben Sie unten Ihre Firmendaten ein. <br> \ n '+
        'Unser Team überprüft Ihr Unternehmen und genehmigt den Zugriff in kürzester Zeit. <br> \ n '+
        "Vielen Dank, dass Sie unsere Marketingplattform nutzen.",
      per_page: 'Pro Seite',
      every_day: "Jeden Tag",
      date_time: 'Tageszeit',
      day_time: 'Tageszeit',
      whole_day: 'Ganzen Tag',
      time: 'Zeit',
      number_of_client: 'Anzahl der Kunden',
      total_investigated: 'Total untersuchte Kunden',
      official_name: 'Offizieller Firmenname',
      credit_card: 'Kreditkarte',
      credit_card_name: 'Name auf Karte',
      credit_card_number: 'Kartennummer',
      credit_card_expire: 'Kartenablauf (MM/JJ)',
      credit_card_code: 'Kartensicherheitscode',
      setup_net: 'Setup Netto',
      setup_gross: 'Setup Brutto',
      monthly_net: 'Netto pro Monat',
      monthly_gross: 'Brutto pro Monat',
      billing_start: 'Zahlungsstart',
      billing_end: 'Zahlungsende',
      cash: 'Bar',
      sepa: 'SEPA Lastschrift - Bankeinzug',
      bank: 'Bankzahlung',
      billing: 'Zahlung',
      free: 'frei',
      new_client: 'Neue Kunde',
      investigate_potential_client: 'Potentiellen Kunden untersuchen',
      select_investigate_client: 'Untersuchte Firma auswählen',
      owner: 'Besitzer',
      enter_owner_data: 'Eigentümerdaten eingeben',
      enter_name: 'Name eingeben',
      enter_phone: 'Telefon eingeben',
      enter_company_data: 'Firmendaten eingeben',
      technical_investigation: 'Technische Untersuchung',
      provider: 'Anbieter',
      rooms: 'zimmer',
      square_meter: 'Quadratmeter',
      comment: 'Kommentar',
      select_devices: 'Geräte auswählen',

      rating: 'Bewertung',
      reviews: 'Bewertungen',
      total_reviews: 'Insgesamt Bewertungen',
      review_text: 'Bewertung Text',
      total_review_scans: 'Google Bewertungen über QR oder Link',
      review_average: 'Durchschnittliche Bewertung',
      current_google_rating: 'Aktuelle Google Bewertung',

      widget: 'Webseite Widget',
      widget_title: 'Google Bewertung | Webseite-Widget',
      widget_p1: 'Kopieren Sie das folgende Skript und fügen Sie es in Ihre Website ein',
      widget_p2: 'Ihr Widget ist derzeit konfiguriert für',
      widget_p3: 'Wenn Sie Fragen zur Integration haben',

      are_you_sure: 'Sind Sie sicher?',
      cannot_undo: 'Sie können diese Aktion nicht rückgängig machen.',
      yes_proceed: 'Ja, fortfahren',
      no_cancel: 'Nein, abbrechen.',

      copy: 'Kopieren',
      copied: 'Kopiert',
      color: 'Farbe',
      background: 'Hintergrund',
      download: 'Herunterladen',

      review_statistics: 'Statistiken der Bewertungen',
      front_side: 'Vorderseite',
      back_side: 'Rückseite',
      front_side_p: 'Wir schätzen Ihre Meinung',
      front_side_gift_p: 'Lust auf eine Überraschung?',
      back_side_gift_p: 'Sichere dein Geschenk',
      front_side_covid_p: 'COVID-19 Gästeregistrierung \n\n Tischnummer: ___________',
      back_side_covid_p: 'Jetzt registrieren \n\n Tischnummer: _______',
      paper_form: 'Papier Vorlage für die Gästeregistrierung',

      scan_or_visit: 'Scanne QR-Code oder besuche',
      qr_or_link: 'Via QR-Code oder Link',
      rate_on_google: 'Google Bewertung',

      gifts: 'Geschenke',
      gift: 'Geschenk',
      table_poster_gift: 'Geschenk-Konzept Tischplakat',
      table_poster_covid: 'Tischaufsteller für COVID-19 Gästeregistrierung',
      gift_statistics: 'Geschenk Statistiken',
      total_gift_scans: 'Total QR-Geschenkscans',
      total_gift_redeems: 'Total Geschenk-Einlösungen',
      total_gift_sent: 'Total Geschenke verschickt',
      total_menu_openings: 'Gesamt Menü-Öffnungen',
      powered_by: 'powered by',

      hotspot_ads: 'Hotspot mit Werbungen',
      working_days: 'Werktags',
      redirection: 'Weiterleitung zu einer Werbewebsite',
      registration: 'Anmeldung der Gäste',
      support: 'Unterstützung',
      newsletter: 'Newsletter Service',
      google_review: 'Google Rezension Automatisierung',
      sponsorship: 'Exklusives Sponsoring',
      third_party_ad: 'Werbung von Drittanbietern',

      // Covid
      guest_checkin: 'EVID.AT - Gästeregistrierung',
    }),




    // č ć ž š đ
    new MLanguage('Serbian').create({
      english: 'Engleski',
      german: 'Nemački',
      serbian: 'Srpski',
      copyright: 'Autorsko pravo',

      /** HELP PAGE BEGIN */
      generalTitle: 'Sta je zapravo Alideda?',
      general: 'Alideda je najmoćniji Free Wi-Fi mrežni marketing alat. Nudimo našim kupcima odličnu marketinšku priliku. Marketinške karakteristike koje će vaši gosti zapamtiti vašu marku. <br> Best of all is Direct Marketing Campaigns (SMS / Email / Viber) koristeći podatke o kontaktu koji vam pružaju vaši korisnici. To je sjajna prilika da ih kontaktirate, pošaljete ih Birthdai Gifts, Popusti ili ih pozovite na svoj novi događaj. <br> <br> To je jednostavno. Verbung (Advertisement) + Wi-Fi = Alideda. ',
      helpFAQ: `Pomoć - najčešće postavljana pitanja`,
      helpFAQSub: `Često postavljana pitanja i odgovori`,
      advertisingTitle: 'Kako se mogu reklamirati na Alideda-ju?',
      advertising: `Prva opcija je oglašavanje Wi-Fi Hotspot stranice. Možete jednostavno staviti najbolje fotografije i video zapise na svoju Wi-Fi Splash stranicu. Svi koji se pridruže vašem Free-WLAN videće vašu reklamu i uživati u njihovoj pogodnosti. Ovo će iznenaditi vaše korisnike koji koriste Wi-Fi. <br> <br> Druga opcija ist Direct SMS / Email Marketing. Svako ko koristi vaš Wi-Fi je registrovan. Imate njiove telefone / e-poštu i možete ih koristiti za direktne i lične poruke. Ovo će podsjetiti vaše korisnike na vaše poslovanje. <br> <br> Treća opcija je naša Alideda marketing kampanja. Ovde možete da oglašavate po Sesijama u svim našim Hotspotovima. Neka drugi vide svoje dodate na drugoj Wi-Fi mreži u gradu. Ovo će vam donijeti više novih korisnika i napraviti od vas poseban brend.`,
      whatShouldIDo: 'Šta da uradim ukoliko nešto ne razumem?',
      whatShouldIDoText: `<p> U ovoj situaciji možete pretraživati ovu stranicu (FAK) za odgovore na pitanja. Evo najčešćih problema i rešenja. </p> <p> Nudimo i Tutorial stranicu. Ovde u Videos-u smo sve objasnili i pripremili za vas da možete lako razumjeti i iskoristiti svoj najbolji marketinški alat. <br> <n-button disabled> Uskoro ubrzanje </n-button> </p> <p> U najgorem slučaju, ako stranica za pomoć u vezi sa pitanjima (FAK) nije pomogla, slobodno nas kontaktirajte. Spremni smo da rešimo vaš problem u nekoliko trenutaka. </p>`,
      loginControlPanel: 'Kako se mogu prijaviti?',
      loginControlPanelText: `Jednostavno posetite alideda.com i kliknite na dugme Sign In. Navedite svoje korisničko ime i lozinku, i tu ste. Ako ste zaboravili svoju lozinku, jednostavno možete da je resetujete na zaboravljenu lozinku? Dobićete reset vezu po e-pošti. `,
      changePasswordHelp: 'Kako mogu promeniti šifru?',
      changePasswordHelpText: `Možete da promenite lozinku za prijavljivanje na stranici naloga, ovde u admin panelu. Samo ponovite svoju lozinku 2 puta i promijenite se.`,
      costsAlideda: 'Kolika je cena Alideda-ja?',
      costsAlidedaText: `U zavisnosti od paketa koji odaberete za WLAN Alideda hotspot, postoji mnogo mogućih cena. Osnovni mesečni račun će zavisiti od vaših WLAN Hotspot funkcija. Od 49e do 499e mesečno. Nema dodatnih troškova. <br> <br> U zavisnosti od paketa, vaši žetoni će se dodavati svakog meseca, ali za ozbiljnu kampanju oglašavanja morate kupiti više tokena koji cene su: pojedinačni SMS oko 0.1e = 10 žetona i pojedinačna e-poruka oko 0.01e = 1 Credit. <br> <br> Naše marketinške kampanje ostavit će vas bez daha, jer oni povećavaju vašu reklamu na svakoj Alideda žarištu u zemlji. Ove kampanje su zasnovane na interakciji, a troškovi zavise od cilja i količine interakcija (po prikazu, klikanju ili sličnom do 7 žetona). <br> Ipak, Alideda je veoma jeftin i pristupačan za bilo koji omiljeni Brand-nev-business. `,
      discountAlideda: 'Da li mogu dobiti specijalan popust za Alideda?',
      discountAlidedaText: `Da naravno. Za bolje cene, veći broj tokena ili još mnogo više kampanja, molimo vas da nas kontaktirate. Napravićemo vam ponudu koju ne možete odbiti :) <br> <br> Naš savjet takođe treba da prati naše čarobnjaka i savete, jer postoje određeni periodi u godini ili samo specijalni dani kao crni petak, nova godina itd. kada nudimo posebne cene za marketinške tokove. `,
      advertisementAlidedaWebsite: 'Koliko košta reklamiranje na sajtu Alideda-ja?',
      advertisementAlidedaWebsiteText: `Vi kao kompanija Alideda imate jednu reklamu GRATIS na Alideda veb sajtu. Inače je koštao 200 evra za reklamu. Tu nudite popuste za Alideda korisnike ili jednostavno promovišete svoje poslovanje sa nekim lepim fotografijama i tekstom. Za promenu ove reklame, molimo Vas da nas kontaktirate ili pošaljete izmjene kao e-poštu na info@alideda.com ili koristite našu kontakt adresu. `,
      howCampaignWorksTitle: `Kako funkcioniše Campaign Marketing?`,
      howCampaignWorksText: `Marketing kampanje Alideda je najbolji način da promovišete svoje poslovanje veoma širokim i dubokim direktnim novim korisnicima i postanite popularni brend. Vaš oglas bi mogao biti direktno postavljen kao promocija na svakoj Alideda žarištu - to će koštati pro interakciju (1 pogled = 0,03€) i kliknite (1 klik = 0,05€) ili slično (1 lajk = 0,07€).`,
      monthlyFeeTitle: `Ja imam veću mesečnu tarifu nego druga kompanija. Zašto?`,
      monthlyFeeText: `Alideda ima punu opciju za pojedinačne funkcije Wi-Fi Hotspot-a, kao i mogućnost individualnog ugovora. Mjesečna naknada zavisi od količine hardvera, prve jednokratne instalacije za plaćanje, Hotspot Features, dužine ugovora itd. Ako želite promeniti svoju mesečnu naknadu, slobodno nas kontaktirajte, možemo ugovoriti ugovor kako želite. <b> Postoji i opcija da postanete 50% popusta na mesečnu naknadu, dok preporučujemo naše usluge nekome drugom. </b> Jednostavno, cenimo naše klijente lojalnosti. </div>`,
      featuresDashboardHelp: `Koje funkcije imaju kontrolnu tablu Dashboard?`,
      featuresDashboardHelpText: `Naša moćna i mobilna kontrolna tabla kontrolne table će vam pomoći da promenite neke osnovne Wi-Fi reklame kao tekstove, fotografije itd. Takođe, neka osnovna konfiguracija kao vreme za Internet vezu, ograničenje brzine interneta, broj povezanih korisnika itd. <br> <br > Možete pratiti dnevnu vezu za Wi-Fi vezu i neke druge statistike i analitike kao korisnici zemalja, korisnici telefona / e-pošte itd. Naša statistika će vas pripremiti za najbolje i najčešće dane u godini. Uvek ćete biti korak ispred vremena. Uz pomoć naše kontrolne table Dashboard možete kontaktirati svoje korisnike putem SMS-a ili e-pošte. Jednostavno pozovite svoje korisnike na događaju, pošaljite im diskontne kupone ili želite im srećan rođendan itd. <br> Oglašavanje na drugim Alideda hotspotima je naša posebna karakteristika koju možete podesiti u nekoliko koraka tako što ćete povećati svoje oglase. <br> Bogate i moćne statistike, onlajn žeton za kupovinu direktnih poruka marketinga, stranica sa najčešćim pitanjima, promena karakteristika Wi-Fi-a i celokupan paket, pregled svih klijenata i povećanje oglašavanja preko Alideda-ovih hotspotova su mali deo naše moćne kontrolne table Dashboard-a.`,
      dashboardProblem:`Imam neke probleme sa Admin Panelom. Šta sad?`,
      dashboardProblemText:`Prva stvar koju možete učiniti je da izbrišete sve keširane datoteke u vašem pregledaču. Zatim ponovo učitajte stranicu. Još jedna stvar koju možete učiniti je da se odjavite i prijavite ponovo. Ako je to neka velika stvar, molimo vas da kontaktirate podršku putem uživo ćaskanja ili kontakt formular. Naša FAK (Pomoć) ili stranica za upućivanje vam takođe mogu pomoći da rešite problem. Može vam doneti samo nekoliko trenutaka. `,
      statisticsHelp: `Statistika`,
      statisticsHelpText: `Evo najvažnijih statističkih podataka i analitike vašeg Wi-Fi-a, kao što su mesečne, dnevne i nedeljne karte za povezivanje. Postoji nekoliko tabulatora koji pokazuju koliko su korisnici na mreži, ukupan broj popupa spamova, broj različitih korisnika koji su se pridružili vašem Alideda Wi-Fi mreža i ukupni zaradjeni novac na našoj platformi omogućavajući drugima da plasiraju svoje oglase na svoj oglasni prostor. Karte mogu biti veoma korisne za planiranje sezone i cena ili za vidjeti koji su dani / meseci najčešći i shodno planu vaše lično. `,
      advertisingHelp: `Reklame`,
      advertisingHelpText: `Na ovoj stranici možete kreirati nove oglase ili samo uređivati postojeće. Za svaku reklamu možete izabrati jedan ili više medija, jedan naslov do 150 znakova, jedan tekst do 300 znakova i do 5 oznaka. Kada ste napravili oglas, on će se pojaviti samo na svojoj Hotspot stranici, ali sačekajte, možete na svakoj drugoj strani u prvoj liniji u zemlji pokrenuti novu marketinšku kampanju. `,
      galleryHelp:`Galerija`,
      galleryHelpText:`Za svaku reklamu vam je potreban dodatni sadržaj. Možete ga otpremiti ovde. Imajte na umu da ćemo vam isecati slike maksimalnim odnosom 1: 1, tako da Vaše slike sa portretima možda neće biti pravilno isecane. Korišćenje pejzažnih slika u omjeru od 4: 3 je naša preporuka za najbolje korisničko iskustvo. `,
      configurationHelp:`Konfiguracija`,
      configurationHelpText:`Ovo je stranica za osnovnu konfiguraciju Alideda Hotspot stranice, kao što je vreme autorizacije interneta, opcije prijavljivanja, prioritet prijave i ciljna stranica, koja će biti posjećena nakon veze. `,
      messageServiceHelp:`Servis poruka`,
      messageServiceHelpText:`Ova stranica je najvažnija stranica ako želite da osetite pravu moć Alideda direktnog SMS / Email marketinga. U četiri jednostavna koraka možete da upišete SMS / e-poštu i sa našim filterom odaberete najbolju Korisničku grupu koja odgovara vašim potrebama. Postotak slanja ove poruke automatski se menja dok promenite svoj filter i broj korisnika. Cena će biti prikazana u eurima. <br> Funkcije filtera <br> 1. Tip poruke - Izaberite ako želite da pošaljete SMS poruke ili e-poštu. U pravu ste da vidite koliko je dostupnih korisnika za tu vrstu poruke. <br> 2. Države - odakle dolaze vaši korisnici. Uz svaku zemlju je broj korisnika odatle i dostupan je za gore odabranu vrstu poruke. <br> 3. Age Range - Izaberite starosnu grupu kojoj želite poslati poruku. Podrazumevano je postavljeno od 18 do 60 godina. Promena broja korisnika starosnog područja može biti vrlo smanjena. <br> 4. Rod - Podrazumevano je podešen na oba pola. Ako želite poslati posebnu poruku samo za jedan rod, na primer dan majke ili oca, itd. 5. Vreme registracije - Kada ste se registrovali na Wi-Fi Hotspot-u. Možda želite poslati poruku samo novim ili starim korisnicima. Možete odabrati i poseban opseg. Podrazumevano je postavljeno od početka do danas. <br> 6. Rođendano vreme - Vaši korisnici uskoro imaju svoj omiljeni dan? Pošaljite im neke rođendanske ponude ili samo im poželjni srećan rođendan. <br> 7. Broj poseta - Ovdje možete odabrati korisnike vaših lojalnosti i poslati im popuste ili čak i korisnici koji imaju manje od 5 puta povezani što znače da nisu toliko česte i oni se takođe mogu podsetiti na vas sa nekom lepom porukom. `,
      creditsHelp:`Kredit`,
      creditsHelpText:`Na ovoj stranici ćete kupiti kredit za SMS / Email marketing kampanje. U 3 jednostavna koraka možete odabrati količinu toka, odabrati vrstu plaćanja i pregledati i odštampati svoj račun. Možete kupiti token u tri vrste plaćanja. Credit-/Debit Card, Paipal ili Sofort. Veoma je važno štampati vaš račun za vaše računovodstvo. Međutim, možete ga naći u bilo kom trenutku na Dashboard > Računi.`,
      invoicesHelp:`Računi`,
      invoicesHelpText:`Ovo je jednostavna stranica na kojoj možete pronaći sve svoje mesečne naknade i sve <b> račune koje ste napravili online za kupovinu Alideda kredita </b> za različite marketinške svrhe. Ovi žetoni se koriste za svaku kupovinu na našoj platformi i nikad ne ističe. Takođe možete razmjenjivati tokene za pravi novac ako želite, samo nas kontaktirajte. `,
      otherServicesHelp:`Druge usluge Alideda-ja`,
      otherServicesHelpText:`Mogli smo se znati jedni drugima možda malo bolje. Evo nekih naših drugih usluga koje pružamo. Sve ove karakteristike su u posebnim popustima samo za naše lojalne kompanije. Ponosni smo što imamo priliku da se predstavimo. Svi IT servisi, bez obzira da li su hardver ili softver, imamo najbolje inženjere za vas. <br> <b> Veb lokacije, veb aplikacije, fotografije i dizajn </b> su samo mali deo onog što možemo. `,
      /** HELP PAGE END */


      sms: 'SMS',
      first_name: 'Ime',
      email: 'Email',
      price_per_message: 'Cena po poruci: 0.0{0}€',
      whatsapp: 'WhatsApp',
      viber: 'Viber',
      messenger: 'Facebook Messenger',
      tripadvisor: 'TripAdvisor',
      popup: 'Pop-up',
      direct: 'Direkt',
      edit: 'Izmeni',
      add: 'Dodaj',
      log_out: 'Odjavi se',
      language: 'Jezik',
      account: 'Profil',
      register: 'Registracija',
      login: 'Prijava',
      forgot_password: 'Zaboravili ste lozinku',
      change_password: 'Promenite lozinku',
      verify_account: 'Verifikacija naloga',
      reset_password: 'Resetujte lozinku',
      new_password: 'Nova lozinka',
      repeat_password: 'Ponovite lozinku',
      enter_email: 'Unesite email',
      already_have_account: 'Već imate nalog?',
      boost_title: 'Reklama za Boost',
      monthly_campaign: 'Mesečna kampanja',
      one_time_campaign: 'One-time kampanja',
      monthly_campaign_settings: 'Podešavanja mesečne kampanje',
      one_time_campaign_settings: 'Podešavanja One-time kampanje',
      campaign_investments: 'Investicije u kampanju:',
      sorry_more_credits: 'Žao nam je, morate kupiti još kredita za ovu kampanju. Trenutno stanje kredita {credit}€',
      buy_more_credits: 'Kupiti još kredita',
      per_view_price: 'Po Pregledu: 0.03€',
      per_click_price: 'Po Kliku: 0.05€',
      per_like_price: 'Po Lajku: 0.07€',
      prices: 'Cene',
      campaign_type: 'Vrsta kampanje',
      locations: 'Lokacije: ',
      register_title1: 'Automatizirajte marketing',
      register_desc1: 'Neka vaš Wi-Fi prodaje marketing za vas.',
      register_title2: 'Prikupite podatke o gostima',
      register_desc2: 'Prikupite i analizirajte detaljne podatke o gostima.',
      register_title3: 'Direktni marketing',
      register_desc3: 'Ostanite u kontaktu sa svojim gostima putem našeg Nevslettera.',
      wifi_posts: 'WiFi Reklame',
      wifi_statistics: 'WiFi-Statistika',
      statistics: 'Statistika',
      clients: 'Klijenti',
      devices: 'Uređaji',
      aps: 'Access Points',
      urls: 'Kratki Linkovi',
      accounts: 'Nalozi',
      guests: 'Gosti',
      message_service: 'Servis poruka',
      billboard_posts: 'Bilbord Reklame',
      indoor_billboards: 'Reklamni ekrani',
      invoices: 'Fakture',
      invoice: 'Faktura',
      payment_method: 'Način plaćanja',
      product: 'Produkt',
      net: 'Netto',
      vat: 'PDV',
      refresh_hotspot: 'Osveži Hotspot',
      configuration: 'Podešavanja',
      package: 'Paket',
      contact: 'Kontakt',
      help: 'Pomoć',
      enter: 'Unesite',
      create_new_ad: 'Napravite novu reklamu',
      enter_description: 'Unesite opis',
      enter_title: 'Unesite naslov',
      enter_tags_text: 'Uneti Tagove - Max 5- Odaberite već postojeće za vise pregleda, ili kreirajte novi',
      enter_tag: 'Kreirajte Tag',
      selectMedias: 'Izabrati medije',
      online: 'Trenutno online',
      incl_investigation: 'Ukljčujući istraživanja',
      client: 'Klijent',
      client_statistics: 'Statistika klijenata',
      total_connections: 'Ukupno poseta',
      average_daily_connections: 'Prosečno poseta dnevno',
      total_money_earned: 'Ukupno zarađeno novca',
      money_earned_this_month: 'Zarađeno novca ovog meseca',
      monthly_connections: 'Mesečne konekcije',
      today: 'Danas',
      reset_form: 'Resetujte formu',
      advanced_settings: 'Napredna podešavanja',
      or: 'Ili',
      no: 'Bez',
      coming_soon: 'Uskoro dostupno.',
      connections: 'Konekcija/e',
      last_30_days: 'Učestalost konekcija u poslednjih 30 dana',
      last_24_hours: 'Konekcije grupisane u 24 časa',
      during_the_day_connections: 'Učestalost konekcija grupisana u 24 sata',
      weekly_connections: 'Nedeljne konekcije',
      connections_in_one_week: 'Konekcije po danima u toku nedelje',
      during_the_week: 'Učestalost konekcija grupisana po danima u nedelji',
      cancel: 'Poništi',
      gallery: 'Galerija',
      duration_in_sec: 'Trajanje u sekundama',
      enter_duration_in_sec: 'Unesite trajanje u sekundama',
      select_file: 'Izaberite fajl',
      upload_via_external_link: 'Uploaduj sa eksternog linka',
      upload: 'Uploaduj',
      no_file: 'Nema fajla',
      drop_files: 'Prevucite fajl',
      upload_new: 'Uploaduj nove medije',
      upload_media_type: 'Izaberite tip medija pre upload-a',
      cancel_editing_promotion: 'Poništi',
      error: 'Greška',
      created: 'Kreirano',
      deleted: 'Obrisano.',
      data_not_valid: 'Podaci nisu validni',
      getDateAndTimeCreateFrom: 'Početni datum i vreme promocije',
      success: 'Uspeh',
      active: 'Aktivno',
      crop: 'Iseci',
      and: 'I',
      credits_success_1: 'Kredit je dodat na vaše stanje',
      credits_success_2: 'Hvala na ukazanom poverenju!',
      credits_error_1: 'Izvinite, vaša uplata nije uspela.',
      credits_error_2: 'Nije bilo nikakvih plaćanja.',
      payment_type: 'Način plaćanja',
      click_checkout: 'Kliknite završi da biste platili',
      credit: 'Kredit',
      price: 'Cena',
      amount: 'Količina',
      balance_after_deposit: 'Stanje nakon uplate',
      buy_again : 'Kupite ponovo',
      buy_credits_title: 'Kupi tokene',
      choose_amount: 'Izaberite iznos',
      choose_type: 'Izaberite tip',
      payment_option: 'Način plaćanja',
      choose: 'Izaberi',
      birthday: 'Datum rođenja',
      media: 'Medij',
      photo: 'Slika',
      title: 'Naslov',
      description: 'Opis',
      from: 'Od',
      to: 'Do',
      showing: 'Prikaz {from} do {to} od ukupno {total} redova',
      name: 'Ime',
      type: 'Tip',
      payment: 'Način plaćanja',
      date: 'Datum',
      total: 'Ukupno',
      status: 'Status',
      discount: 'Popust',
      gross: 'Sa porezom',
      number: 'Broj',
      saved: 'Sačuvano.',
      save: 'Sačuvati',
      next: 'Dalje',
      user_filter: 'Filter korisnika',
      recipients: 'Primaoci',
      campaign_investment: 'Investicija u kampanju - ',
      company_filter: 'Filter Kompanija',
      age: 'Godine',
      gender: 'Pol',
      both: 'Oba',
      male: 'Muško',
      female: 'Žensko',
      message: 'Poruka',
      type_sms_150_long: 'Molimo unesite vašu {0} znakova dugu SMS ',
      make_email: 'Napravite vaš prelepi Email.',
      total_receiving_message: 'Ukupno primalaca',
      total_costs_message: 'Ukupna cena ove poruke',
      deposit: 'Uplata',
      total_costs: 'Ukupna cena',
      total_guests: 'Ukupno gostiju',
      current_balance: 'Trenutno stanje',
      remaining_credits: 'Preostalo kredita',
      email_html: 'Email',
      type_email_title: 'Unesite vaš naslov za email',
      type_email_text: 'Unesite vaš text za email',
      summary: 'Rezime',
      campaign: 'Kampanja',
      success_campaign_message_1: 'Uspešno napravljena kampanja.',
      success_campaign_message_2: 'Naš tim će pregledati vašu kampanju i početi to što je brže moguće. Ako imate nekih problema, kontaktiraćemo vas. Hvala što koristite našu kampanju. :)',
      authorization_time: 'Vreme za Wi-Fi Internet vezu | Vrednost u minutima',
      promoPage: 'Reklamna stranica nakon povezivanja putem hotspota',
      on: 'Uključeno',
      off: 'Isključeno',
      login_priority: 'Prioritet opcije za prijavu gosta preko WiFi | Email ili SMS',
      login_on_visit: 'Login na posetu',
      explanation_configuration: 'Samo sopstvene reklame - Ako je omogućeno, nije moguće zaraditi tokene tako što ćete dozvoliti drugima da koriste vaš reklamni prostor',
      date_picker_texts : {
        night: 'Dan',
        nights: 'Dani',
        'day-names': ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'],
        'check-in': 'Početni datum',
        'check-out': 'Krajnji datum',
        'month-names': ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar'],
      },
      print: 'Ištampaj',
      send_on_email: 'Pošalji na email',
      boost: 'Promoviši',
      delete: 'Obriši',
      actions: 'Akcije',
      edit_company_profile: 'Izmenite podatke kompanije',
      address: 'Adresa',
      company: 'Kompanija',
      companies: 'Kompanije',
      phone: 'Broj telefona',
      emailOrUsername: 'Email / Korisničko ime',
      username: 'Korisničko ime',
      password: 'Lozinka',
      current_password: 'Trenutna lozinka',
      city: 'Grad',
      country: 'Država',
      postal_code: 'ZIP',
      about_company: 'O kompaniji',
      about_company_placeholder: 'Kratak opis kompanije',
      short_description: 'Slogan',
      short_description_p: 'Slogan - Poruka koja se pokazuje ispod imena kompanije',
      update_profile: 'Izmenite Profil',
      new_guests_per_month: 'Novi gosti po mesecima',
      search: 'Pretraga...',
      blocked: 'Blokiran',
      type_message: 'Unesite vasu poruku',
      finish: 'Završi',
      previous: 'Nazad',
      package_title: 'Izaberite najbolji Wi-Fi Marketing paket za vas',
      up_to: 'Do',
      guest_login: 'Registracija gostiju',
      choose_package: 'Izaberi paket',
      sponsorship: 'Sponzorstvo',
      package_success_1: 'Uspešno zatraženi paket.',
      package_success_2: 'Naš tim će pregledati vaš zahtev za nadogradnju i povećati vašu marketinšku moć što je brže moguće. Ako postoji neki problem, kontaktiraćemo vas. Hvala za nadogradnju paketa. :)',
      package_error_1: 'Žao mi je, vaš zahtev za nadogradnju nije poslat.',
      package_error_2: 'Nešto nije pošlo naopako, molimo kontaktirajte podršku na support@verbifi.com.',
      contact_us: 'Kontaktirajte nas',
      contact_form: 'Kontakt Forma',
      send_message: 'Pošalji poruku',
      message_start: 'Dragi Alideda Tim, imam jednostavno pitanje za vas:',
      send_message_success_1: 'Uspešno poslata poruka.',
      send_message_success_2: 'Naš tim će pregledati vašu poruku i poslati u željeno vreme. Ako bude bilo nekih problema, kontaktiraćemo vas. Hvala na korišćenju naše kontakt usluge. :)',
      send_message_error_1: 'Izvinite, vaša poruka nije poslata.',
      send_message_error_2: 'Nešto nije pošlo naopako, molimo kontaktirajte nas na support@alideda.com.',
      select_recaptcha: 'Molimo štiklirajte Recaptchu.',
      verify_success: 'Verifikacija je uspešna. Prijavite se sada. ',
      success_reset: 'Lozinka je uspešno promenjena.',
      password_not_same: 'Lozinke nisu iste.',
      password_too_short: 'Lozinka je prekratka.',
      check_your_inbox: 'Proverite svoj inbox',
      create_new: 'Kreiraj novo',
      manufacturer: 'Proizvođač',
      template: 'Templejt',
      create_new_template: 'Naprite novi {0} Templejt',
      template_preview: 'Pregled templejta',
      select_template: 'Izaberite templejt poruke',
      message_template: 'Nachricht Vorlage',
      message_template_desc: 'Kreirajte svoj templejt za ponovnu upotrebu',
      create_template_success: 'Templejt uspešno kreiran',
      pick_from_gallery: 'Izaberi iz galerije',
      button_text: 'Text na dugmetu',
      button_link: 'Link od dugmeta',
      button_text_color: 'Boja teksta na dugmetu',
      button_bg_color: 'Boja pozadine na dugmetu',
      footer_text: 'Text Footera',

      finish_bulk1: 'Vi ste jedan korak od slanja "bulk" poruke.',
      finish_bulk2: 'Molimo vas da izaberete procenjeno vreme za izvršavanje ovog "bulka".',
      bulk_requests: 'Bulk Zahtevi',
      select_date_time: 'Izaberi datum i vreme',
      message_type: 'Vrsta poruke',
      subject: 'Predmet',
      view: 'Pogledaj',
      filter: 'Filter',
      countries: 'Zemlje',
      languages: 'Jezici',
      visits: 'Posete',
      registration_time: 'Vreme registracije',
      execution: 'Izvršenje',
      scheduled_time: 'Zakazano vreme',
      requested_time: 'Traženo vreme',
      price_estimated: 'Procenjena cena',
      price_real: 'Cena realna',
      sent_at: 'Poslano u',
      not_executed_yet: 'Još nije izvršeno',
      close: 'Zatvori',
      unknown: 'Nepoznato',
      registered_via: 'Registrovan preko',
      see_you_soon: 'Vidimo se uskoro',
      pick_template: 'Molimo izaberite templejt za slanje',
      choose_time: 'Molimo odaberite vreme izvršenja',
      all_checked: 'Sve označeno',
      templateNoticeSMS: '<span style="color: red;"> VAŽNO </span> <br> <br> \n' +
      'Proverite da li imate na kraju naziv svog preduzeća, <br> \n' +
      'tako da primaoci to znaju od koga su dobili poruku. <br> <br> \n '+
      'Koristite "%recipient.name%" za promenljivu ime primaoca u vašoj poruci. <br> <br> \n '+
      'SMS sadrži 160 znakova, ali 25 je rezervisano za odjavu. <br> \n '+
      'Ako koristite specijalne znakove ili emoji-je, dužina će se smanjiti.',
      name_your_template: 'Nazovite ovaj templejt',
      message_short: 'Poruka prekratka.',
      subject_short: 'Naslov prekratak.',
      message_long: 'Poruka preduga.',
      subject_long: 'Naslov predug.',
      html_short: 'HTML je prekratak.',
      text_short: 'Tekst prekratak.',
      wrong_birthday_range: 'Pogrešan raspon rođendana',
      wrong_registration_range: 'Pogrešan datumski raspon registracije',
      wrong_url: 'Pogrešan URL',
      no_users_for_this_filter: 'Nijedan korisnik nije pronašao ovaj filter',
      name_template: 'Molimo da date naziv svog templejta',
      char_left: 'Preostalo karaktera',
      auto_google_reviews: 'Automatski Google pregledi poslati 2 sata nakon što se gost registrovao',
      for_example: 'Na primer',
      website: 'Web stranica',
      select_language: 'Izaberi jezik',
      select_country: 'Izaberi zemlju',
      company_type: 'Tip kompanije',
      welcome_on_board: 'Dobrodošli. <i class = "now-ui-icons emoticons_satisfied"> </i> <br> \n '+
        'Ispunite podatke kompanije u nastavku. <br> \n '+
        'Naš tim će pregledati vašu kompaniju i odobriti pristup u vrlo kratkom roku. <br> \n '+
        'Hvala vam što koristite našu marketinšku platformu.',
      per_page: 'Po stranici',
      every_day: 'Svaki dan',
      date_time: 'Dnevno vreme',
      day_time: 'Dnevno vreme',
      whole_day: 'Celi dan',
      time: 'Vreme',
      number_of_client: 'Broj klijenata',
      total_investigated: 'Ukupno istraženih klijenata',
      official_name: 'Službeno ime firme',
      credit_card: 'Kreditna karta',
      credit_card_name: 'Ime na kartici',
      credit_card_number: 'Broj kartice',
      credit_card_ekpire: 'Vreme isteka kartice (MM/GG)',
      credit_card_code: 'Sigurnosni kod kartice',
      setup_net: 'Setup bez poreza',
      setup_gross: 'Setup sa porezom',
      monthly_net: 'Mesečno bez poreza',
      monthly_gross: 'Mesečno sa porezom',
      billing_start: 'Početak plaćanja',
      billing_end: 'Kraj plaćanja',
      cash: 'Keš',
      sepa: 'SEPA - Zaduzivanje preko banke',
      bank: 'Plaćanje preko banke',
      billing: 'Plaćanje',
      free: 'Besplatno',
      new_client: 'Novi klijent',
      investigate_potential_client: 'Istražite potencijalnog klijenta',
      select_investigate_client: 'Izaberi kompaniju koja je istraživana',
      owner: 'Vlasnik',
      enter_owner_data: 'Unesite podatke o vlasniku',
      enter_name: 'Unesite ime',
      enter_phone: 'Unesite telefon',
      enter_company_data: 'Unesite podatke kompanije',
      technical_investigation: 'Tehnička istraga',
      provider: 'Provajder',
      rooms: 'Sobe',
      square_meter: 'Kvadratni metar',
      comment: 'Komentar',
      select_devices: 'Izaberite uređaje',

      rating: 'Ocena',
      reviews: 'Recenzije',
      total_reviews: 'Ukupno Recenzija',
      review_text: 'Tekst Recenzije',
      total_review_scans: 'Google recenzije pomoću QR ili linka',
      review_average: 'Prosečna ocena',
      current_google_rating: 'Trenutna ocena na Google',

      widget: 'Vidžet za websajt',
      widget_title: 'Google Rejting | Vidžet za websajt',
      widget_p1: 'Kopirajte sledeću skriptu i zalepite je na svoju web stranicu',
      widget_p2: 'Vaš vidžet je trenutno konfigurisan za',
      widget_p3: 'Ako imate bilo kakvih pitanja u vezi integracije\n',

      are_you_sure: 'Da li ste sigurni?',
      cannot_undo: 'Ne možete poništiti ovu akciju.',
      yes_proceed: 'Da, nastavi',
      no_cancel: 'Ne, otkaži.',

      copy: 'Kopirajte',
      copied: 'Kopirano',
      color: 'Boja',
      background: 'Pozadina',
      download: 'Preuzimanje',

      review_statistics: 'Statistika recenzija',
      front_side: 'Prednja strana',
      back_side: 'Zadnja strana',
      front_side_p: 'Cenimo vaše mišljenje',
      front_side_gift_p: 'Želiš iznenađenje?',
      back_side_gift_p: 'Uzmi svoj poklon',
      front_side_covid_p: 'COVID-19 Prijava gostiju \n\n Broj stola: _________',
      back_side_covid_p: 'Registrujte se unosom \n\n broja stola: _________',
      paper_form: 'Papir forma za registraciju',

      scan_or_visit: 'Skeniraj QR ili poseti',
      qr_or_link: 'Skeniraj QR ili poseti',
      rate_on_google: 'Ocenite nas na Google',

      gifts: 'Pokloni',
      gift: 'Poklon',
      table_poster_gift: 'Poster za sto sa konceptom poklona',
      table_poster_covid: 'Poster za sto za COVID-19 registraciju',
      gift_statistics: 'Statistike Poklona',
      total_gift_scans: 'Ukupno skeniranja QR',
      total_gift_redeems: 'Totalno iskorišćenih poklona',
      total_gift_sent: 'Totalno poslatih poklona',
      total_menu_openings: 'Totalno otvaranja menija',
      powered_by: 'powered by',

      hotspot_ads: 'Hotspot sa reklamama',
      working_days: 'Radnim danima',
      redirection: 'Redirekcija na promo websajt',
      registration: 'Registracija gostiju',
      support: 'Podrška',
      newsletter: 'Newsletter Servis',
      google_review: 'Automatizacija Google Recenzija',
      third_party_ad: 'Reklama drugih biznisa',

      // Covid
      guest_checkin: 'EVID.AT - Registracija gostiju',
    })
  ]
})
